export default "__VITE_ASSET__DnHdLIld__"